import React from 'react';
interface CTAButtonProps {
  label: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  label,
  href = '#offer',
  className = ''
}: CTAButtonProps) {
  return <a href={href} className={`cta-button flex min-h-[54px] w-full items-center justify-center rounded-[10px] bg-gold px-6 py-4 text-center text-base font-extrabold text-navy shadow-lg shadow-gold/25 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-[17px] ${className}`} data-id="element-61" data-mp="2kyeqbdw64g19">
      {label}
    </a>;
}